<div class="my-3 my-md-5">
  <div class="container">
      <div class="page-header">
          <h1 class="page-title">
              <span *ngIf="!LocationId">Adding Location</span>
              <span *ngIf="LocationId">Update Location</span>
          </h1>
      </div>
      <div class="card">
          <form [formGroup]="locationForm" (submit)="createLocation()">

              <div class="card-body">
                  <div class="container-fluid">
                      <div class="row">
                          <div class="col-md-4 col-lg-4">
                              <label class="form-label">City *</label>
                              <mat-select  placeholder="City" formControlName="city_id" (click)="setSearchValue('city')">
                                <input class="mySearchInput"
                                #citySearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'city')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="citySearch">
                                <mat-option>Select City</mat-option>
                                  <mat-option [value]="city.id" *ngFor="let city of cityList">{{city.name}}</mat-option>
                              </mat-select>
                              <div *ngIf="submitted && f.city_id.errors" class="invalid-feedback">
                                  <div *ngIf="f.city_id.errors.required">City is required</div>
                              </div>
                          </div>
                          <div class="col-md-4 col-lg-4 right-border">
                              <div class="form-group">
                                  <label class="form-label">Location Name *</label>
                                  <input type="text" placeholder="Location Name" formControlName="name" class="form-control" />
                                  <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                      <div *ngIf="f.name.errors.required">Location Name is required</div>
                                  </div>
                              </div>
                          </div>
                          <div class="col-md-4 col-lg-4">
                              <label class="form-label">Status *</label>
                              <mat-select  placeholder="Status" formControlName="status">
                                  <mat-option [value]="1">Active</mat-option>
                                  <mat-option [value]="0">In-Active</mat-option>

                              </mat-select>
                              <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                  <div *ngIf="f.status.errors.required">Status is required</div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="card-footer">
                  <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i>
                       <span *ngIf="!LocationId">Create Location</span>
                      <span *ngIf="LocationId">Update Location</span>
                  </button>
              </div>
          </form>
      </div>
  </div>
</div>
